var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menubar",class:{ 'menubar--gradient': _vm.gradient }},[_c('router-link',{attrs:{"to":"/"}},[_c('FeedbackCompanyLogo',{attrs:{"height":32}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }